import { render, staticRenderFns } from "./OldReviewReport.vue?vue&type=template&id=0c465b5d&"
import script from "./OldReviewReport.vue?vue&type=script&lang=js&"
export * from "./OldReviewReport.vue?vue&type=script&lang=js&"
import style0 from "./OldReviewReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports